import { appSwitchRoutes } from 'constants/routes';
import { useCandidateAcceptIndirectInvitationMutation } from 'generated/graphql';
import { getAccessToken } from 'helpers/auth';
import { parseIndirectInvitationUrl } from 'helpers/indirectInvitation';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Loader,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';

export const IndirectInvitation: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleMsgType } = useNotification();

  const indirectInvitationData = parseIndirectInvitationUrl(location.search);

  const [candidateAcceptIndirectInvitationMutation] =
    useCandidateAcceptIndirectInvitationMutation({
      onCompleted: data => {
        const accessToken = getAccessToken();
        if (
          indirectInvitationData &&
          accessToken &&
          data.CandidateAcceptIndirectInvitation
        ) {
          // Land on the invited stage's actions page — it owns the
          // identity-verification, adjustments and anti-cheat gates.
          const { role, stageId } = data.CandidateAcceptIndirectInvitation;
          navigate(appSwitchRoutes.roleStageActions.getUrl(role.id, stageId));
        }
      },
      onError: error => {
        handleMsgType({
          type: TNotification.error,
          message: error?.message,
        });

        navigate('/');
      },
    });
  useEffect(() => {
    if (indirectInvitationData) {
      candidateAcceptIndirectInvitationMutation({
        variables: {
          stageId: indirectInvitationData.stageId,
          hiringManagers: indirectInvitationData.hiringManagers,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader isPageLoader />;
};
